import { useMemo, useCallback, useState, useEffect } from 'react';
import axios from 'axios';
import { DASHBOARD_ENDPOINTS, STORAGE_KEYS } from '../constants/api';

export const useAgentDashboard = (
    userId?: string
) => {
    const [ffcStatus, setFFCStatus] = useState<any>(null);
    const now = useMemo(() => new Date(), []);

    // FFC status fetcher for agent
    const fetchFFCStatus = useCallback(async () => {
        if (!userId) {
            setFFCStatus(null);
            return;
        }
        try {
            const headers = {
                Authorization: `Bearer ${sessionStorage.getItem(STORAGE_KEYS.TOKEN)}`,
            };

            const response = await axios.get(DASHBOARD_ENDPOINTS.AGENT_FFC_STATUS, {
                params: { userId },
                headers
            });
            const data = response.data;
            if (data && data.status && data.expiry) {
                const expiry = data.expiry ? new Date(data.expiry) : null;
                setFFCStatus({ status: data.status, found: true, expiry: expiry ? expiry.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' }) : null, docId: data.docId || null });
                return;
            }
        } catch (error) {
            setFFCStatus({ status: "Failed", found: false, expiry: "N/A", docId: "N/A" });
            console.error('Error fetching Agent FFC status:', error);
        }
    }, [userId]);

    // Recompute local stats when inputs change
    useEffect(() => {
        fetchFFCStatus();
    }, [fetchFFCStatus]);

    return { ffcStatus };
};